import clsx from 'clsx';
import { toAbsoluteUrl } from '../../../helpers';
import { HeaderNotificationsMenu, HeaderUserMenu } from '../../../partials';
import { useThemeMode } from '../../../partials/layout/theme-mode/ThemeModeProvider';
// import { useLayout } from '../../core'
// Media
import NotificationSVG from '../../../../umart_admin/assets/media/svg_uMart/bell.svg';
import { getAuth, useAuth } from '../../../../app/modules/auth';
import { UEAT_URL } from '../../../../utils/constants';
import { useEffect, useRef, useState } from 'react';
import APICallService from '../../../../api/apiCallService';
import { dashBoardEndPoints } from '../../../../api/apiEndPoints';
const itemClass = 'ms-1 ms-lg-3';
const btnClass = 'btn btn-icon btn-custom btn-icon-muted';
const userAvatarClass =
  'symbol-40px symbol-md-45px symbol-lg-50px symbol-circle';
// const btnIconClass = 'svg-icon-1'
const Navbar = () => {
  const { mode, updateMode } = useThemeMode();
  // const { config } = useLayout()
  const [showNotifications, setShowNotifications] = useState(false);
  const { currentUser } = useAuth();
  const userInitial =
    (currentUser?.name || currentUser?.email || 'A').trim().charAt(0).toUpperCase() ||
    'A';
  const notificationRef = useRef<HTMLDivElement | null>(null);
  const [count, setCount] = useState(0);
  useEffect(() => {
    (async () => {
      await fethcNotificationCount();
    })();
  }, []);
  useEffect(() => {
    if (showNotifications) {
      document.addEventListener('click', handleClickOutSide);
    } else {
      document.removeEventListener('click', handleClickOutSide);
    }
    return () => {
      document.removeEventListener('click', handleClickOutSide);
    };
  }, [showNotifications]);

  const fethcNotificationCount = async () => {
    const apiCallService = new APICallService(
      dashBoardEndPoints.notifcationCount
    );
    const response = await apiCallService.callAPI();
    if (response) {
      setCount(response?.unreadItems?.length || 0);
    }
  };
  const handleMarkAsRead = async () => {
    const apiCallService = new APICallService(dashBoardEndPoints.markAsRead);
    const response = await apiCallService.callAPI();
    if (response) {
      await fethcNotificationCount();
    }
  };
  const handleToggle = () => {
    const token = getAuth();
    const url = `${UEAT_URL}?token=${token}`;
    window.open(url, '_blank');
  };
  const handleClickOutSide = (event: any) => {
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target)
    ) {
      setShowNotifications(false);
    }
  };
  return (
    <div className="app-navbar flex-shrink-0">
      <div className={clsx('app-navbar-item', itemClass)}>
        <div className="admin-platform-switch d-flex align-items-center me-5 fw-500" role="group" aria-label="Platform switch">
          <button
            type="button"
            className="admin-platform-tab btn d-inline-flex align-items-center gap-2 fs-14 px-3 py-2 active"
            aria-current="page"
          >
            <i className="bi bi-bag" aria-hidden="true" />
            U-Mart
          </button>
          <button
            type="button"
            className="admin-platform-tab btn d-inline-flex align-items-center gap-2 fs-14 px-3 py-2"
            onClick={() => handleToggle()}
          >
            <i className="bi bi-shop" aria-hidden="true" />
            U-Eat
          </button>
        </div>
        <button
          type="button"
          className="admin-theme-toggle btn btn-icon btn-custom w-35px h-35px flex-shrink-0 mx-2"
          aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}
          title={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}
          onClick={() => updateMode(mode === 'dark' ? 'light' : 'dark')}
        >
          <i className={`bi ${mode === 'dark' ? 'bi-sun' : 'bi-moon'} fs-3`} aria-hidden="true" />
        </button>
        <div ref={notificationRef}>
          <div className={btnClass}>
            <div className="position-relative">
              <img
                className="img-fluid cursor-pointer"
                src={NotificationSVG}
                alt=""
                onClick={() => {
                  setShowNotifications(!showNotifications);
                  handleMarkAsRead();
                }}
              />
              {count ? (
                <span
                  className="bullet bullet-dot bg-success position-absolute translate-end top-10 start-400 animation-blink"
                  style={{
                    top: '-3px',
                    right: '-3px',
                    height: '7px',
                    width: '7px',
                  }}
                ></span>
              ) : (
                <></>
              )}
            </div>
          </div>
          {showNotifications && (
            <HeaderNotificationsMenu show={showNotifications} />
          )}
        </div> 
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
        >
          <div className="symbol symbol-50px symbol-circle">
            <div className="symbol-label fs-1 fw-bold bg-light-primary text-primary admin-user-initial">
              {userInitial}
            </div>
          </div>
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  );
};
export { Navbar };
